import qccapis  from "../../api/qcc";
import apis from "../../api/index";
import flowapis  from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";

export default {
    name: "BankBossAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
            query: {
                userName: "",
            },
            isVisible:this.visible,
            detailResult:{},
            caseResult:["","","",""],
            llTableData:[],
            cllTableData:[],
            llListResult:[],
            llShow:false,
            cllShow:false,
            llquery:false,
            credit:{num:"暂无",comment:"暂无"},
            flowInfo:{},
            fileList:[],
            picList:[],
            reasonVisible:false,
            queryTime:dateUtils.dateToStr("yyyy-MM-dd hh:mm:00",new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if(meta&&meta.permBtns.length>0){
          this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      onChangeClose(){
        this.isVisible = false
      },
      onChangeOpen(){
        this.isVisible = true
      },
      queryClick(flag){
        let that=this;
        let data={};
        if(flag==1){
            if(this.llTableData.length>0){
                this.llShow=!this.llShow
                this.cllShow=false
                if(this.llquery){
                  return
                }else {
                  this.llquery=true
                }
                data = this.llTableData[0];
            }else{
                return
            }
        }else{
            if(this.cllTableData.length>0){
                this.cllShow=!this.cllShow;this.llShow=false;
                if(this.cllquery){
                  return
                }else {
                  this.cllquery=true
                }
                data = this.cllTableData[0]
            }else{
                return
            }
        }
        qccapis.getLLDetail({id:data.Id}).then(res => {
            if(res!=null){
              if(flag==1){
                that.llListResult = res.Result.Data
              }else {
                that.cllListResult=res.Result.Data
              }
          }else{
            that.$message.error("查询老赖失信列表信息失败")
          }
        });
      },
      queryData(row){
        let that = this
        if(row){
          that.flowInfo = row
          // 查询营业执照
          const yyzz = qccapis.getCPDetail({id:row.Code})
          // 诉讼信息
          const ssxx = qccapis.getCPCase({id:row.Code})
         // 查询老赖信息
         const llxx = qccapis.getLL({idCard:row.IdCard})
         // 查询老赖信息
         const llxx2 = qccapis.getLL({idCard:row.Code})
          // 查询流程文件
          const lcfiles = flowapis.getLoanFiles({processId:row.Id,uploadType:'1'})

          // // 查询政务信息
          // const promise3 = 

          Promise.all([yyzz, ssxx , llxx,llxx2,lcfiles]).then((res) => {
            if(res.length===5){
              if(res[0]&&res[0]['Result']){
                that.detailResult = res[0]['Result']
              }else{
                that.detailResult = {}
              }

              if(res[1]['Result']&&res[1]['Result']['Data']){
                that.caseResult = res[1]['Result']['Data']
              }else{
                that.caseResult = {}
              }
              if(res[2]['Result']&&res[2]['Result']['Data']){
                let llTableData = res[2]['Result']['Data']
                let list = []
                for(let i=0;i<llTableData.length;i++){
                  let cerNo=llTableData[i].CerNo.replace('<em>', '')
                  llTableData[i].CerNo=cerNo.replace('</em>', '')
                  if(llTableData[i].Name === this.keyword || llTableData[i].Name === that.flowInfo.Name){
                    list.push(llTableData[i])
                  }
                }
                that.llTableData=list
              }else{
                that.llTableData = []
              }
              if(res[3]['Result']&&res[3]['Result']['Data']){
                  let cllTableDataTemp = res.Result.Data;
                  if(cllTableDataTemp){
                      for(var i=0;i<cllTableDataTemp.length;i++){
                        let cerNo=cllTableDataTemp[i].CerNo.replace('<em>', '');
                        cllTableDataTemp[i].CerNo=cerNo.replace('</em>', '');
                      }
                      that.cllTableData=cllTableDataTemp;
                  }
              }else{
                that.cllTableData = []
              }
              if(res[4]&&res[4].length>0){
                that.picList = []
                that.fileList = []
                for(let f=0;f<res[4].length;f++){
                  if(res[4][f]['Type']+'' === '1'){
                    that.picList.push({
                      name:res[4][f]['Name'],
                      url:res[4][f]['Url']
                    })
                  }else{
                    that.fileList.push({
                      name:res[4][f]['Name'],
                      url:res[4][f]['Url']
                    })
                  }
                }
              }else{
                that.fileList = []
                that.picList = []
              }
            }
          })
        }
      },
      beforeAvatarPicUpload(file) {
          let that = this
          const isJPG = 
              file.type ==="image/jpg"||
              file.type ==="image/jpeg"||
              file.type ==="image/png"
          const isLt2M = file.size/1024/1024 <2
          if(!isJPG){
              that.$message.error("仅支持jpg、png格式的图片")
          }
          if(!isLt2M){
              that.$message.error("上传图片大小不能超过2MB") 
          }
          return isJPG && isLt2M
      },
      uploadPicFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.picList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
        }
        return true
      },
      uploadFileFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.fileList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handlePicRemove(file) {
        let that = this
        if(file){
          for(let i=0;i<that.picList.length;i++){
            if(file.url===that.picList[i].url){
              that.picList.splice(i,1)
            }
          }
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePicDownload(file) {
        if(file){
          fetch(file.url,{
            mode: 'cors',
          })
          .then((response) => response.blob())
          .then((res) => {
            const blob = new Blob([res])
            const elink = document.createElement('a')
            elink.download = file.name
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          });
        }
      },
      /**
       * 银行拒绝通过
       */
      onReturnFlow(){
        let that = this
        this.$prompt('', '必须填写拒绝的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value && value != ''){
                  let param = {
                    Id:that.flowInfo.Id,
                    Route:4,
                    RefuseReason:value,
                    BankName:that.flowInfo.BankName,
                    State:'4',
                    RefuseType:'2'
                  }
                  flowapis.updateFlow(param).then((res) => {
                    if(res&&res.code){
                      done()
                    }else{
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    }
                  })
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
            // that.$emit('bankbossauditsucess');
            that.onChangeClose()
            that.$parent.bankAuditSucess()
        }).catch(() => {
               
        });
      },
      /**
       * 银行通过
       */
      onPassFlow(){
        let that = this
        let param = {
          Id:that.flowInfo.Id,
          Route:4,
          BankName:that.flowInfo.BankName
        }
        flowapis.updateFlow(param).then((res) => {
          if(res&&res.code){
              // that.$emit('bankbossauditsucess');
              that.onChangeClose()
              that.$parent.bankAuditSucess()
          }else{
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
      }
    },
  };
